<template lang="">
  <div class="chart-box">
    <div ref="chart" class="chart"></div>
  </div>
</template>

<script>
import { loadChart } from "../charts/line_common_1_Data";
// import datas from "../../data/lineCommon1";
// import { getRandom } from "@/util/index";
export default {
  props: {
    unit: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    datas: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    datas: {
      handler() {
        this.getData();
      },
      immediate: true
    }
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    // this.getData();
  },
  methods: {
    getData() {
      // get("/api/restful/cyzl/getMMLZPriceTrend").then(res => {
      //   console.log("new data ===", res);
      //   let data = datas.echartsData;
      if (this.datas.length > 0) {
        let data = { "2023": this.datas };
        let typeList = [];
        let bfData = [];
        let firstYear = "";
        for (let key in data) {
          console.log("key", key);
          if (!firstYear) {
            firstYear = key;
          }
          typeList.push(key + "年");
          bfData.push(
            data[key].map(e => {
              return e.price;
              // return getRandom(5, 24);
            })
          );
        }
        let xdata = data[firstYear].map(e => {
          if (e.date) {
            return e.date.replace(/^\d{4}-/, "");
          }
          return " ";
        });
        console.log("x data ==", xdata);
        const unit = this.unit || "人数";
        loadChart(this.chart, typeList, xdata, bfData, unit, this.title); // 最后一个变是备注
      }
      // });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.flex
  display flex
  justify-content center

.chart-box
  width 100%
  height 100%
  position relative
  .tab-box
    position absolute
    top 15px
    right 4%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
</style>
